import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import header from 'modules/AllBillers/assets/header.png';

import './TncPreview.style.less';

class TncPreview extends PureComponent {
  decodeHtml = escapedHtml => {
    const unescapedHtml = unescape(escapedHtml);
    const fontFamilyNativeRegex = /font-family: Native Font;/g;

    return unescapedHtml
      .replace(fontFamilyNativeRegex, '')
      .split('px')
      .map((element, index, array) => {
        if (index < array.length - 1) {
          const word = element.split(' ');
          const fontSizeIndex = word.length - 1;

          const fontSize = (parseFloat(word[fontSizeIndex]) / 10).toString();
          word[fontSizeIndex] = `${fontSize}rem`;

          return word.join(' ');
        }
        return element;
      })
      .join('');
  };

  render() {
    return (
      <div className="tnc-h5-wrapper" style={this.props.style}>
        <div>
          <img src={header} className="statusbar" alt="statusbar" />
          <div
            className="title-bar"
            style={{
              width: 330,
              margin: '33px 35px',
            }}
          >
            Service Name
          </div>
        </div>

        <div className="preview-tnc">
          <div
            className="content-tnc"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: this.decodeHtml(this.props.htmlContent),
            }}
          />
        </div>
      </div>
    );
  }
}

TncPreview.propTypes = {
  htmlContent: PropTypes.string,
  style: PropTypes.object,
};

export default TncPreview;
